{
  "main": {
    "title": "Data Filtering"
  },
  "labels": {
    "datumOd": "Date FROM:",
    "datumDo": "Date TO:",
    "klubPJ": "Select glider pilot club:",
    "klubPM": "Select powered aircraft pilot club:",
    "klubJ": "Select glider club:",
    "klubM": "Select powered aircraft club:",
    "pilot": "Select pilot:",
    "reg": "Select aircraft registration:",
    "casV": "Tow time:",
    "stLetov": "Number of flights:",
    "casVZ": "Time in air:"
  },
  "data": {
    "title": "Data"
  },
  "buttons": {
    "csv": "Export to CSV",
    "natisni": "Print",
    "poslji": "Send",
    "brisiIzbiro": "Clear selection",
    "brisiZapis": "Delete record"
  },
  "table": {
    "reg": "REG",
    "vzlet": "TAKEOFF",
    "pilot": "PILOT",
    "trajanje": "DURATION",
    "naloga": "TASK",
    "datum": "DATE",
    "pristanek": "LANDING",
    "titleJ": "List of Glider Flights"
  },
  "modal": {
    "izbran": "Selected record",
    "reg": "registration:",
    "pilot": "pilot:",
    "regV": "tow aircraft reg.:",
    "instruktor": "instructor:",
    "namen": "purpose:",
    "naloga": "task:",
    "casV": "takeoff time:",
    "casO": "release time:",
    "casP": "landing time:",
    "casL": "flight time:",
    "casVL": "tow time:",
    "opomba": "note:",
    "datumL": "flight date:",
    "datumV": "entry date:"
  }
}